import { PageSEO } from '@/components/base/PageSEO';
import { HeroSection } from './components/HeroSection';
import { StatsSection } from './components/StatsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { CategoriesSection } from './components/CategoriesSection';
import { ArticlesSection } from './components/ArticlesSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '一起草',
  url: 'https://jlsjhjt.cn',
  description: '一起草是一个AI智能内容创作平台，提供AI写作、文章润色、大纲生成等一站式内容创作解决方案。',
  foundingDate: '2024',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9999',
    email: 'support@yiqicao.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '一起草',
  url: 'https://jlsjhjt.cn',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://jlsjhjt.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '一起草官网入口_官方直达通道',
  description: '为您提供一起草官网入口的最新访问地址、功能介绍与使用指南，帮助用户快速找到一起草官网入口，安全登录，畅享全部核心功能服务。',
  url: 'https://jlsjhjt.cn/',
  isPartOf: { '@id': 'https://jlsjhjt.cn/#website' },
  about: { '@id': 'https://jlsjhjt.cn/#organization' },
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="首页"
        description="一起草官网入口为您提供AI写作、文章润色、大纲生成等一站式内容创作解决方案。安全登录，畅享全部核心功能服务。"
        keywords="一起草官网入口,一起草官方网站,一起草登录入口,一起草注册地址,一起草最新入口,一起草平台访问,一起草使用指南"
        canonicalUrl="/"
        ogType="website"
        schema={[organizationSchema, websiteSchema, webPageSchema]}
      />
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}